
/**
 * Erzeugt einen Circle, deren UV-Koordinaten mit der Größe skaliert sind
 */
export default class CircleUvBufferGeometry extends THREE.BufferGeometry {

    constructor( radius, segments, thetaStart, thetaLength ) {
        super();

        this.type = 'CircleBufferGeometry';

        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };

        radius = radius || 1;
        segments = segments !== undefined ? Math.max( 3, segments ) : 8;

        thetaStart = thetaStart !== undefined ? thetaStart : 0;
        thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

        // buffers

        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];

        // helper variables

        var i, s;
        var vertex = new THREE.Vector3();
        var uv = new THREE.Vector2();

        // center point

        vertices.push( 0, 0, 0 );
        normals.push( 0, 0, 1 );
        uvs.push( 0.5, 0.5 );

        for ( s = 0, i = 3; s <= segments; s ++, i += 3 ) {

            var segment = thetaStart + s / segments * thetaLength;

            // vertex

            vertex.x = radius * Math.cos( segment );
            vertex.y = radius * Math.sin( segment );

            vertices.push( vertex.x, vertex.y, vertex.z );

            // normal

            normals.push( 0, 0, 1 );

            // uvs

            uv.x = ( vertices[ i ] ) / 2;
            uv.y = ( vertices[ i + 1 ] ) / 2;

            uvs.push( uv.x, uv.y );

        }

        // indices

        for ( i = 1; i <= segments; i ++ ) {

            indices.push( i, i + 1, 0 );

        }

        // build geometry

        this.setIndex( indices );
        this.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
        this.setAttribute( 'normal', new THREE.Float32BufferAttribute( normals, 3 ) );
        this.setAttribute( 'uv', new THREE.Float32BufferAttribute( uvs, 2 ) );

    }

}
